import { type AnalyticsEvents } from '../types/events'

/**
 * item_sku 只給 Aletheia，GA4 / TikTok / Statsig 等平台會原封轉送 eventParams，要先拿掉
 */
export const omitItemSku = (event: AnalyticsEvents): AnalyticsEvents => {
  const items: unknown = 'items' in event.eventParams ? event.eventParams.items : undefined
  if (!Array.isArray(items) || !items.some(item => 'item_sku' in item)) return event
  return {
    ...event,
    eventParams: {
      ...event.eventParams,
      items: items.map(({ item_sku, ...item }) => item),
    },
  } as AnalyticsEvents
}
